module.exports = __webpack_public_path__ + "media/img/camellie-e6e93bcd.jpg";